// Column configuration for Model Reviewer/Preparer Dashboard

export const modelsColumns = [
  {
    id: 'company_name',
    label: 'Company Name',
    isSortable: true,
    align: 'left' as const,
    disablePadding: false,
  },
  {
    id: 'valuation_status',
    label: 'Valuation Status',
    isSortable: true,
    align: 'left' as const,
    disablePadding: false,
  },
  {
    id: 'model_status',
    label: 'Model → Status',
    isSortable: true,
    align: 'left' as const,
    disablePadding: false,
  },
  {
    id: 'notes',
    label: 'Notes',
    isSortable: false,
    align: 'left' as const,
    disablePadding: false,
  },
  {
    id: 'model_reviewer',
    label: 'Model → Reviewer',
    isSortable: false,
    align: 'left' as const,
    disablePadding: false,
  },
  {
    id: 'model_preparer',
    label: 'Model → Preparer',
    isSortable: false,
    align: 'left' as const,
    disablePadding: false,
  },
  {
    id: 'supporting_due_date',
    label: 'Model → Due Date',
    isSortable: true,
    align: 'left' as const,
    disablePadding: false,
  },
  {
    id: 'valuation_lead',
    label: 'Valuation Lead',
    isSortable: false,
    align: 'left' as const,
    disablePadding: false,
  },
  {
    id: 'valuation_date',
    label: 'Valuation Date',
    isSortable: false,
    align: 'left' as const,
    disablePadding: false,
  },
];
